import {checkPassport} from '@router/guards/roleGuard'
export default {
  path: '/materialgroup',
  component: () => import('@views/MaterialGroup/Index'),
  beforeEnter: checkPassport,
  children: [
    {
      path: 'index',
      name: 'materialgroup.index',
      component: () => import('@/components/MaterialGroup/MaterialGroup')
    }
  ]
}
